<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>Path for the userid value to generate the code:
        <input type="text" [(ngModel)]="seConfiguration.userIdSource" />
    </label>
    </div>
</div>

<div class="grid-x grid-margin-x">
    <div class="cell small-12">
        <label>Path for the code value after user is created:
        <input type="text" [(ngModel)]="seConfiguration.codeTarget" />
    </label>
    </div>
</div>